import { useState, useEffect } from 'react'

/**
 * Resolves and safely fetches a caption (.vtt) file based on a video URL.
 * Handles redirects, CORS, and returns a blob URL for reliable playback.
 */
export function useResolvedCaptionsUrl(videoUrl) {
  const [captionsUrl, setCaptionsUrl] = useState('')

  useEffect(() => {
    if (!videoUrl) return

    const buildCaptionsUrl = (url) => {
      try {
        const parsed = new URL(url)
        const basePath =
          parsed.origin +
          parsed.pathname.substring(0, parsed.pathname.lastIndexOf('/') + 1)
        return `${basePath}captions.vtt`
      } catch {
        return ''
      }
    }

    const fetchCaptions = async () => {
      const directUrl = buildCaptionsUrl(videoUrl)
      if (!directUrl) return

      try {
        const res = await fetch(directUrl, { mode: 'cors' })
        if (!res.ok) throw new Error('Failed to fetch captions')
        const blob = await res.blob()
        const objectUrl = URL.createObjectURL(blob)
        setCaptionsUrl(objectUrl)
      } catch (err) {
        console.warn('Captions unavailable:', err)
        setCaptionsUrl('')
      }
    }

    fetchCaptions()

    // Cleanup old blob URLs when video changes or component unmounts
    return () => {
      if (captionsUrl.startsWith('blob:')) URL.revokeObjectURL(captionsUrl)
    }
  }, [videoUrl])

  return captionsUrl
}
